// import * as yup from 'yup'

import bodyMeasurementsSchema from './bodyMeasurementsSchema'

const newMeasurementFormSchema = (t, birthDate) => bodyMeasurementsSchema(t, birthDate)

export default newMeasurementFormSchema
